// White
export const baseColor1 = `#ffffff`;
// Navy
export const baseColor2 = `#2b2e7e`;

// Light Blue
export const logoColor1 = `#70d6fd`;
// Light Green
export const logoColor2 = `#64d49d`;
// Yellow
export const logoColor3 = `#fbce73`;
// Red
export const logoColor4 = `#f79bb5`;

export const accentColor1 = `#9ee4fe`;
export const accentColor2 = `#96e2bc`;
export const accentColor3 = `#fddfa2`;
export const accentColor4 = `#fabdce`;

export const sidebarBgColor = `#fcfdff`;
export const lightBaseColor1 = `#aaabcb`;
export const dividerColor = `#e4e4ee`; // 20% opacity lightBaseColor1

export const inputDefaultColor = `#f2f3f7`;
export const inputHoverColor = `#e9eaf2`;
export const inputDisabledBgColor = `#f7f7f7`;
export const inputDisabledColor = `#cccccc`;

export const buttonDisabledBgColor = `#dddddd`;
export const buttonDisabledColor = `#7d7d7d`;

export const navHoverColor = `#e9eaf2`;

export const errorColor = `#ff0048`;

export const loadingShimmer = `#fafbff`;
